import { createSlice } from '@reduxjs/toolkit';
import { clearTranslationDrafts } from '../utils/drafts';
import { clearAuthToken } from '../utils/authToken';

// Define initial state
const initialState = {
    token: null,
    isAuthenticated: false,
    user: null,
    isLoading: true,
};

// Create the auth slice
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        // Action to handle login success
        loginSuccess: (state, action) => {
            state.token = action.payload.token;
            state.isAuthenticated = true;
            state.user = action.payload.user;
            state.isLoading = false;
        },

        // Action to handle logout
        logout: (state) => {
            state.token = null;
            state.isAuthenticated = false;
            state.user = null;
            state.isLoading = false;

            // Remove the auth token and any saved drafts from storage
            clearAuthToken();
            clearTranslationDrafts();

        },

        authCheckCompleted: (state) => {
            state.isLoading = false;
        },
    },
});

// Export actions
export const { loginSuccess, logout, authCheckCompleted } = authSlice.actions;

// Export the reducer
export default authSlice.reducer;

